// extracted by mini-css-extract-plugin
export default {"main":"BFilterTag-module_main_b87c0cf6"};